import volumetric from "../images/volumetric-img.png"
import Blog from "../component/Blog";
import Cta from "../component/Cta";
import { Helmet } from "react-helmet";
export default function Volumetric() {
  return (
        <div>
            <Helmet>
                <title>Parcelx - Volumetric</title>
            </Helmet>
            <section className="section03">
                <div className="container-fluid">
                    <div className="col-md-11 mx-auto">
                        <div className="row align-items-center">
                            <div className="col-md-8 order-md-2 mb-3">
                                <img src={volumetric} className="img-fluid" alt="" />
                            </div>
                            <div className="col-md-4 mb-3">
                                <div className="section-heading">
                                    <h2 className="heading">Volumetric Weight <span>Calculator...</span></h2>
                                    <p className="">Volumetric weight is the weight of a package based on its size, not just its actual weight. It's used by couriers to charge fairly charge.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row weight-box align-items-center">
                            <div className="col-md-8">
                                <h2 className="heading-title fw-600">Enter Dimensions of the Parcel</h2>
                                <p>Volumetric Weight (kg)=(Length x BreadhxHeight)/5000</p>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div>
                                            <label htmlFor="Length" className="form-label">Length</label>
                                            <input className="form-control" id="Length" placeholder="Enter Length" type="text"/>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div>
                                            <label htmlFor="Breadth" className="form-label">Breadth</label>
                                            <input className="form-control" id="Breadth" placeholder="Enter Breadth" type="text"/>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div>
                                            <label htmlFor="Height" className="form-label">Height</label>
                                            <input className="form-control" id="Height" placeholder="Enter Height" type="text"/>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="input-search-box">
                                            <button className="btn btn-primary w-100 btn-sm mt-auto">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-10 ms-auto">
                                        <div className="totle-box">
                                            <p>Volumetric Wt. of the parcel is</p>
                                            <h2 className="main-heading-title mb-0">192</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Blog />
            <Cta />
        </div>
    );
}
